import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import styles from './create-account.module.scss';
import CreateAccountUiStore from "./create-account-ui-store";
import { observer } from 'mobx-react';
import Alert from '@mui/material/Alert';
import { useFormik } from 'formik';
import FormHelperText from '@mui/material/FormHelperText';
import { ArrowSquareRight } from 'iconsax-react';
import logo from '../../logo.png';
import { Grid } from "@mui/material";
import PasswordField from "../shared/components/password-field";
import LoadingButton from '@mui/lab/LoadingButton';
import SignUpSchema from "../shared/forms-schemas/signup-schema";

const uiStore = new CreateAccountUiStore();

const CreateAccount = observer(({ history, context, location }) => {
    const { submitData, error } = uiStore;
    const [loading, setLoading] = useState(false);
    
    const url = new URLSearchParams(location?.search);
    const redirect = url.get('redirect');

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            firstName: '',
            lastName: '',
            agreeToTerms: ''
        },
        validationSchema: SignUpSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const result = await submitData(values);
            setLoading(false);
            if (result) {
                history.push('/login?success=true&redirect=' + redirect);
            }
        },
    });

    useEffect(() => {
        if (context.authenticatedUser?.id) {
            history.push('/dashboard');
        }
        
    }, [context, history]);

    return (
        <Grid container>
            <Grid sx={{ backgroundColor: '#FFF' }} item xl={6} lg={6} md={12} sm={12} xs={12}>
                <Box className={styles.formContainer}>
                    <Box className={styles.headerLogo}>
                        <a href="/">
                            <img className="logo" src={logo} alt='logo' />
                        </a>
                    </Box>

                    <Box className={styles.heading}>
                        <Typography variant="h3" color="#242333" sx={{ mb: 1, fontWeight: '600' }}>Register</Typography>
                        <Typography variant="p" color="#888888" >Start creating your cards now</Typography>
                    </Box>

                    {error &&
                        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                    }

                    <Box
                        component="form"
                        className={styles.formBox}
                        onSubmit={formik.handleSubmit}
                    >
                        <TextField
                            required
                            id="firstName"
                            label="First Name"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                            helperText={formik.touched.firstName && formik.errors.firstName}
                        />
                        <TextField
                            required
                            id="lastName"
                            label="Last Name"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                            helperText={formik.touched.lastName && formik.errors.lastName}
                        />
                        <TextField
                            required
                            id="email"
                            label="Email Address"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />

                        <PasswordField
                            required
                            id="password"
                            label="Password"
                            formik={formik}
                            validate
                        />

                        <FormGroup sx={{ m: 0 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id="agreeToTerms"
                                        value={formik.values.agreeToTerms}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                }
                                label="I consent to the Terms of Service."
                            />
                            <FormHelperText error>
                                {formik.touched.agreeToTerms && Boolean(formik.errors.agreeToTerms) ?
                                    formik.errors.agreeToTerms
                                    :
                                    ''
                                }
                            </FormHelperText>

                        </FormGroup>


                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            endIcon={
                                <ArrowSquareRight
                                    size="24"
                                    color="#FFFFFF"
                                    variant="Bulk"
                                />
                            }
                            disableElevation
                            className={styles.loginbtn}
                            type='submit'
                            disabled={!!loading}
                        >
                            Register
                        </LoadingButton>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', mt: "5vh" }}>
                        <Button color="grey" href='/' sx={{ p: 1 }} size='small'>Have an account?
                            <Typography color='#242333' variant="p" sx={{ ml: 2 }}> Login</Typography>
                        </Button>
                    </Box>
                </Box>
            </Grid>
            <Grid className={styles.gradiantBackground} item xl={6} lg={6} display={{ lg: "block", md: "none", sm: "none", xs: "none" }}>
                <Box className={styles.imgbackground}>
                    <Typography variant="h3" color="white" sx={{ mb: 1, fontWeight: '700', textAlign: 'center' }}>Stay in touch </Typography>
                    <Typography variant="h3" color="white" sx={{ mb: 1, fontWeight: '200', textAlign: 'center' }}>with your community</Typography>
                </Box>
            </Grid>
        </Grid>
    );
});

export default CreateAccount;